import * as React from "react";
import CancelSubscription from "../../components/CancelSubscription";
import Headline from "../../components/Headline";
import { MainLayout } from "../../components/Layout";
import { Link } from "react-router-dom";
import { URL_PATHS } from "../../routes";

const CancelSubscriptionProcedurePage = (): JSX.Element => {
    return (
        <MainLayout>
            <Headline>
                <span>
                    有料会員プランは
                    <br />
                    以下の手順で停止・継続できます
                </span>
            </Headline>
            <CancelSubscription />
            <div className="finish-cation">
                有料会員を停止してもアカウントは削除されません。
                <br />
                <Link to={URL_PATHS.contractPaidMember()}>
                    退会申請は契約確認・変更から行えます。
                </Link>
            </div>
        </MainLayout>
    );
};

export default CancelSubscriptionProcedurePage;
